// extracted by mini-css-extract-plugin
export default {"gameLayer":"GameFrame_gameLayer__3ao2T","gamePrepare":"GameFrame_gamePrepare__gCtpH","iframe":"GameFrame_iframe__7IJjz","display":"GameFrame_display__ZVUlo"};